import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { Baseurl } from "../../config/BaseUrl";

const getCachedData = (key) => {
  try {
    if (typeof window !== "undefined") {
      const local = localStorage.getItem(key);
      if (local) return JSON.parse(local);
      const session = sessionStorage.getItem(key);
      if (session) return JSON.parse(session);
    }
    return [];
  } catch (e) {
    return [];
  }
};

const initialState = {
  superCatTotal: getCachedData("cached_superCatTotal"),
  isLoading: false,
  supercatLoading: false,
};

export const getSuperCategory = createAsyncThunk(
  "SuperCategory/getSuperCategory",
  async (thunkAPI) => {
    try {
      const url = `${Baseurl}/api/v1/supercategory/all`;
      const resp = await axios(url);
      return resp.data.supercategories;
    } catch (error) {
      return thunkAPI.rejectWithValue("supercategories Not Found");
    }
  }
);

const SuperCategorySlice = createSlice({
  name: "superCategory",
  initialState,
  extraReducers: {
    [getSuperCategory.pending]: (state) => {
      state.isLoading = true;
    },
    [getSuperCategory.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.supercatLoading = false;
      state.superCatTotal = action.payload || [];
      try {
        if (typeof window !== "undefined") {
          localStorage.setItem("cached_superCatTotal", JSON.stringify(action.payload));
          sessionStorage.setItem("cached_superCatTotal", JSON.stringify(action.payload));
        }
      } catch (e) {}
    },
    [getSuperCategory.rejected]: (state, action) => {
      state.isLoading = false;
    },
  },
});

export default SuperCategorySlice.reducer;
